// extracted by mini-css-extract-plugin
module.exports = {"splatWrap":"SplatCanvas_splatWrap__2DwP0","splat":"SplatCanvas_splat__2BiuX"};